/**
 * Centralized guard to prevent overlapping TTS/audio playback.
 * When playback is active, new requests are ignored (not stopped-and-restarted).
 * Used by playAudio (audioUtils) and speakGameWord for consistent behavior across all modes.
 */

let isPlaying = false;

/** Returns true if playback is currently active. */
export function isAudioPlaying(): boolean {
  return isPlaying;
}

/**
 * Request to start playback. Returns true if allowed, false if already playing (caller should return early).
 */
export function requestStartPlayback(): boolean {
  if (isPlaying) return false;
  isPlaying = true;
  return true;
}

/**
 * Release the playback lock. Must be called when playback ends (onended, onerror, completion).
 */
export function releasePlayback(): void {
  isPlaying = false;
}
